import React, { FC } from 'react'
import TodaysPaymentReportContainer from 'containers/TodaysPaymentReport'

const TodaysPaymentReportPage: FC = () => <TodaysPaymentReportContainer />

export default TodaysPaymentReportPage
